import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {MedicalRecordProblemModel} from '../../../api/model/medicalRecordProblem.model';
import {MedicalRecordProblemConverter} from '../../../api/converter/medicalRecordProblem.converter';

@Injectable({providedIn: 'root'})
export class MedicalProblemDataService
    extends AbstractDataServiceV2<MedicalRecordProblemModel, MedicalRecordProblemConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: MedicalRecordProblemConverter) {
        super('MedicalProblem', http, httpUrlGenerator, logger, config, converter);
    }
}
